import React from 'react';
import dateFormat from 'dateformat';

class SportunityTable extends React.Component {
  constructor(props) {
    super(props);
    console.log('SportunityTable.constructor', props)
    this.state = {
      activeLine: null
    }
  }

  _highlightLine(index) {
    this.setState({activeLine: index});
  }

  _renderItem(item, index){

    const filterFrom = new Date(this.props.filters.filterFrom);
    const filterTo = new Date(this.props.filters.filterTo);

    let activeClass = (this.state.activeLine == index) ? 'active' : null;

    let {title, beginning_date, ending_date, creation_status, creation_date} = item.node;

    creation_date = new Date(creation_date);

  const sport = item.node.sport.sport.name.EN;
    let organizer = "---";
    if (item.node.organizers) {
      item.node.organizers.forEach(organizerItem => {
        if (organizerItem.isAdmin) {
          organizer = organizerItem.organizer.pseudo;
          return;
        }
      });
    }

    beginning_date = dateFormat(beginning_date, "dd/mm/yyyy HH:MM");
    ending_date = dateFormat(ending_date, "dd/mm/yyyy HH:MM");
    creation_date = dateFormat(creation_date, "dd/mm/yyyy HH:MM");

    return (
      <tr className={activeClass}
        key={index}
        onClick={() => {this._highlightLine(index); this.props.onItemClick(item.node, index, event)}}>
          <td>{index}</td>
          <td>{title}</td>
          <td>{sport}</td>
          <td>{organizer}</td>
          <td>{beginning_date}</td>
          <td>{ending_date}</td>
          <td>{creation_date}</td>
          <td>{creation_status.status}</td>
          <td>
            <button type="button" className="btn btn-danger btn-sm" onClick={(event) => this.props.onEditItemClick(item.node, index, event)}>Modify</button>
          </td>
      </tr>
    );
  }

  onChangeOrder = field => {
    if (field === 'beginning') {
      if (this.props.currentOrder === 'BEGINNING_DATE_ASC') {
        this.props.onChangeOrder('BEGINNING_DATE_DESC');
      }
      else if (this.props.currentOrder === 'BEGINNING_DATE_DESC') {
        this.props.onChangeOrder('BEGINNING_DATE_ASC');
      }
      else {
        this.props.onChangeOrder('BEGINNING_DATE_DESC');
      }
    }
    else if (field === 'creation') {
      if (this.props.currentOrder === 'CREATION_DATE_ASC') {
        this.props.onChangeOrder('CREATION_DATE_DESC');
      }
      else if (this.props.currentOrder === 'CREATION_DATE_DESC') {
        this.props.onChangeOrder('CREATION_DATE_ASC');
      }
      else {
        this.props.onChangeOrder('CREATION_DATE_DESC');
      }
    }
  }

  render() {
    const dataSource = this.props.dataSource;
    return (
      <table className="table table-hover table-condensed">
        <thead>
          <tr>
            <th>NO.</th>
            <th>Title</th>
            <th>Sport</th>
            <th>Organizer</th>
            <th onClick={() => this.onChangeOrder("beginning")}>
              Beginning {this.props.currentOrder === 'BEGINNING_DATE_ASC' ? "(asc)" : this.props.currentOrder === 'BEGINNING_DATE_DESC' ? "(desc)" : null}
            </th>
            <th>Ending</th>
            <th onClick={() => this.onChangeOrder("creation")}>
              Creation Date {this.props.currentOrder === 'CREATION_DATE_ASC' ? "(asc)" : this.props.currentOrder === 'CREATION_DATE_DESC' ? "(desc)" : null}
            </th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {dataSource.map((item, index, arr) => this._renderItem(item, index))}
        </tbody>
      </table>
    )
  }


}

SportunityTable.propTypes = ({
  dataSource : React.PropTypes.array.isRequired,
  onItemClick: React.PropTypes.func.isRequired,
  onEditItemClick: React.PropTypes.func.isRequired,
});




export default SportunityTable;



// WEBPACK FOOTER //
// ./src/components/SportunityTable.js